// ---------------------------------------------------------------------------
// PWA Caisse Tablette — Single product button in the grid
// ---------------------------------------------------------------------------

import type { Product } from '@/lib/types';
import { formatPrice } from '@/lib/price-formatter';

interface ProductButtonProps {
  product: Product;
  onClick: () => void;
}

export default function ProductButton({ product, onClick }: ProductButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex flex-col items-center justify-center gap-1 bg-surface-card rounded-xl p-3 min-h-[72px] hover:bg-surface-hover active:scale-95 transition-all"
    >
      <span className="text-sm font-medium text-white text-center leading-tight line-clamp-2">
        {product.name}
      </span>
      <span className="text-xs text-accent-light font-semibold">
        {product.price_display ?? formatPrice(product.price)}
      </span>
      {!product.has_sequence && (
        <span className="text-[10px] text-warning">Non configure</span>
      )}
    </button>
  );
}
